import { Post } from 'Xhr/Xhr';
import { env } from 'env';
import React, { useEffect, useMemo } from 'react';
import usePartialLocalizationFilter from '../usePartialLocalizationFilter/usePartialLocalizationFilter';

const useCacheLocales = (
  filteredTranslation,
  setWatchLangList
) => {
  const cachedLocales = useMemo(
    () =>
      JSON.parse(localStorage.getItem('languageArray')) ||
      [],
    [JSON.parse(localStorage.getItem('languageArray'))]
  );
  const translation = usePartialLocalizationFilter(
    filteredTranslation
  );

  useEffect(() => {
    const missingTranslations = translation.filter(
      (item) =>
        !cachedLocales.some(
          (cachedItem) =>
            cachedItem.FormKey === item.FormKey
        )
    );

    const shouldFetch = missingTranslations.length > 0;

    if (!shouldFetch) {
      return;
    }
    Post(
      'POST',
      `${process.env.REACT_APP_API_URL_API_GET_TRANSLATION_LIST}`,
      true,
      {
        list: translation,
        AddLang: process.env.REACT_APP_ADD_LANGUAGE,
      }
    ).then((res) => {
      if (res !== undefined)
        if (res.data.resCode === 1) {
          setWatchLangList((prev) => !prev);
          const newLocales = res.data.Data.list;
          const mergedLocales = [
            ...cachedLocales,
            ...newLocales.filter(
              (locale) =>
                !cachedLocales.some(
                  (cachedLocale) =>
                    cachedLocale.FormKey === locale.FormKey
                )
            ),
            ...missingTranslations,
          ];

          localStorage.setItem(
            'languageArray',
            JSON.stringify(mergedLocales)
          );
          setWatchLangList((prev) => !prev);
        }
    });
  }, [translation]);
};

export default useCacheLocales;
